var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group_list" },
    [
      _c(
        "div",
        { staticClass: "btn-group choice_region" },
        _vm._l(_vm.filter_group_draw, function (item) {
          return _c(
            "button",
            {
              staticClass: "btn btn-outline-primary waves-effect waves-themed",
              class: _vm.class_filter_type(item),
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.set_active_filter_group(item)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(item.name) + "\n        ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "panel-tag mt-2 mb-2" }, [
        _c(
          "div",
          {
            staticClass: "btn-group btn-group-sm btn-group-toggle",
            attrs: { id: "js_change_tab_direction", "data-toggle": "buttons" },
          },
          [
            _c(
              "label",
              {
                staticClass:
                  "btn btn-success waves-effect waves-themed cursor-pointer",
                attrs: {
                  "data-action": "",
                  "data-class": "",
                  "data-target": "",
                },
                on: {
                  click: function ($event) {
                    return _vm.check_uncheck(false)
                  },
                },
              },
              [
                _c("input", {
                  attrs: {
                    type: "radio",
                    name: "radioNameTabDirection",
                    value: "nav nav-tabs justify-content-end",
                  },
                }),
                _vm._v(
                  " " + _vm._s(_vm.__t("UNSELECT_ALL")) + "\n            "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "badge badge-primary float-right" }, [
          _vm._v(
            _vm._s(_vm.__t("GROUP_LIST_COUNT")) +
              " " +
              _vm._s(_vm.grouplist.length) +
              " "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.is_load
        ? _c("div", { staticClass: "load_user pt-3" }, [
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("b-spinner", {
                  attrs: { variant: "warning", label: "Text Centered" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("groups_list", { attrs: { groups: _vm.grouplist } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }